import * as yup from "yup";

const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

export const createAdminSchema = yup.object().shape({
  firstName: yup.string().required("Firstname is required"),
  lastName: yup.string().required("Lastname is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup.string().min(6).required("Password is required"),
  phoneNumber: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("Phone number is required"),
  age: yup.number().required("Age is required"),
  profilePicture: yup
    .mixed()
    .required("Profile Picture is required")
    .test(
      "fileSize",
      "File Size is too large",
      (value) => value && value.size <= 1024 * 1024
    )
    .test(
      "fileFormat",
      "Unsupported Format",
      (value) =>
        value &&
        ["image/jpeg", "image/png", "image/jpg", "image/svg"].includes(
          value.type
        )
    ),
});

export const updateAdminSchema = yup.object().shape({
  firstName: yup.string().nullable(),
  lastName: yup.string().nullable(),
  email: yup.string().email("Invalid email").nullable(),
  phoneNumber: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .nullable(),
  age: yup.number().nullable(),
  profilePicture: yup
    .mixed()
    .nullable()
    .test(
      "fileSize",
      "File Size is too large",
      (value) => !value || (value && value.size <= 1024 * 1024)
    )
    .test(
      "fileFormat",
      "Unsupported Format",
      (value) =>
        !value ||
        (value &&
          ["image/jpeg", "image/png", "image/jpg", "image/svg"].includes(
            value.type
          ))
    ),
});

export const loginAdminSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup.string().min(6).required("Password is required"),
});
